import type { ReactNode } from "react";

import { Drawer as MuiDrawer } from "@mui/material";
import { cn } from "utils/styling";

type DrawerProps = {
  anchor?: "left" | "right";
  children: ReactNode;
  className?: string;
  onClose: () => void;
  open: boolean;
  widthClassName?: string;
};

export const Drawer = ({ anchor = "right", children, className, onClose, open }: DrawerProps) => {
  return (
    <MuiDrawer
      anchor={anchor}
      onClose={onClose}
      open={open}
      PaperProps={{
        className: cn("flex h-full w-100 flex-col overflow-hidden bg-lds-surface-bright p-4", className),
      }}
    >
      <div className="flex h-full min-h-0 w-full min-w-0 flex-1 flex-col">{children}</div>
    </MuiDrawer>
  );
};
